import { Component, OnInit, ViewChildren, QueryList, Input, ElementRef } from '@angular/core';
import {
  SortableTableHeaderDirective,
  pagingDefaultSettings
} from '../../../../shared/directives/sortable-table-header.directive';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterService } from '../../../../shared/services';
import { filter } from 'rxjs/operators';
import { TreatmentService } from '../../../../shared/services/treatment.service';
import { UserAuthService } from '../../../../shared/services/user-auth.service';
import { UserRolesService } from '../../../../shared/services/user-roles.service';
import { ThemesSettingsService } from '../../../../shared/services/themes-settings.service';
import { ENUM_THEMES } from '../../../../shared/helpers/app.constants';

@Component({
  selector: 'app-upload-treatment-detail',
  templateUrl: './upload-treatment-detail.component.html',
  styleUrls: ['./upload-treatment-detail.component.scss']
})
export class UploadTreatmentDetailComponent implements OnInit {
  @ViewChildren(SortableTableHeaderDirective) headers: QueryList<SortableTableHeaderDirective>;

  pattern: any = /^[_A-Za-z0-9\s\-[\]()%]*$/;
  patternUnit: any = /^[A-Za-z0-9()/%]*$/;

  isFieldEngineer: boolean = false;

  channelNames = [
    { name: 'Job Time' },
    { name: 'Surf Time' },
    { name: 'Press [Csg]' },
    { name: 'Slurry Flow Rate' },
    { name: 'Proppant Conc' },
  ];

  channelUnits = [
    { name: 'min' },
    { name: 'Date time' },
    { name: 'psi' },
    { name: 'bpm' },
    { name: 'ppg' },
  ];

  isLoadingData: boolean = false;

  channelMapping = [];

  queryParams = null;

  treatmentNumber: number;
  wellName: string = '';

  @Input() dataSource = [];

  pagingState = {...pagingDefaultSettings};
  
  isDarkTheme: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private treatmentService: TreatmentService,
    private toasterService: ToasterService,
    private userAuthService: UserAuthService,
    private userRolesService: UserRolesService,
    private themesSettingsService: ThemesSettingsService
  ) {
    const userInfo = this.userAuthService.getUserInfo();
    const userRole = this.userRolesService.toUserRole(userInfo);
    if (userRole.toLowerCase() === 'field engineer') {
      this.isFieldEngineer = true;
    }
  }

  get dataTable(): any[] {
    return this.dataSource
      .slice(
        (this.pagingState.page - 1) * this.pagingState.pageSize,
        (this.pagingState.page - 1) * this.pagingState.pageSize + this.pagingState.pageSize
      );
  }

  onCheckDarkThemes() {
    const localData = this.themesSettingsService.getLocalStorage();
    if (localData && localData.themes === ENUM_THEMES.Dark) {
      this.isDarkTheme = true;
      if (document.body.classList.value.toString().indexOf('frac-dark-theme') === -1) document.body.classList.add('frac-dark-theme');
    } else {
      this.isDarkTheme = false;
      document.body.classList.remove('frac-dark-theme');
    }
  }

  ngOnInit() {
    this.onCheckDarkThemes();
    this.route.queryParams.pipe(filter(params => params.wellId || params.treatmentId)).subscribe(param => {
      this.isLoadingData = true;
      this.wellName = param.wellName;
      this.treatmentNumber = param.uidTreatmentInterval;
      this.queryParams = param;
      this.treatmentService.getTreatment(param.wellId, param.treatmentId, 'true').subscribe(response => {
        if (response && response.result) {
          this.dataSource = response.result;
          this.pagingState.collectionSize = this.dataSource.length;
        }
        this.isLoadingData = false;
      }, err => {
        this.isLoadingData = false;
      });

      this.treatmentService.getRealtimeChannels(param.wellId, param.treatmentId).subscribe(response => {
        if (response && response.result && response.result.items) {
          this.channelMapping = response.result.items;
        }
      });
    });
  }

  showInlineEdit(event: Event, channel, keyProp) {
    if (channel) {
      event.stopPropagation();
      channel[`${keyProp}IsEditing`] = true;
    }
  }

  saveInlineEdit(event: Event, channel, element, keyProp) {
    const tilteValue = element.value.trim();
    if (channel && keyProp) {
      if (keyProp === 'name') {
        if (!this.pattern.test(tilteValue)) {
          this.toasterService.showError('Title does not contain special characters (except for space, underscore, -, %,(),[])');
          return;
        }
      } else {
        if (!this.patternUnit.test(tilteValue)) {
          this.toasterService.showError('Unit does not contain special characters (except for /, %)');
          return;
        }
      }
      if (element && tilteValue) {
        const channelValue = {
          cName: channel.cName,
          dataType: null,
          name: tilteValue,
          unit: channel.unit,
        }
        this.treatmentService.checkDuplicateUpdateChannel(channelValue, this.queryParams, () => {
        }).subscribe(response => {
          channel[keyProp] = tilteValue;
          event.stopPropagation();
          channel[`${keyProp}IsEditing`] = false;
          this.treatmentService.updateChannel(this.channelMapping, this.queryParams, () => {
          }).subscribe(res => {
            this.toasterService.showSuccess('Updated Successfully');
          });
        }, (error) => {
          channel[`${keyProp}IsEditing`] = true;
        });
      } else {
        if (keyProp === 'name') {
          this.toasterService.showError('The Title is required');
        } else {
          this.toasterService.showError('The Unit is required');
        }
      }
    }
  }

  cancelInlineEdit(event: Event, channel, keyProp) {
    if (channel) {
      event.stopPropagation();
      channel[`${keyProp}IsEditing`] = false;
    }
  }

  changeWellSummary() {
    this.router.navigate(['pages/wells', this.queryParams.wellId]);
  }
}
